module.exports = __webpack_public_path__ + "media/fonts/RecklessNeue-Medium-084d3cf286da3831839dffe9016a303d.ttf";